import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "../i18n/translations";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("moc_lang") || "de");
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem("moc_cart") || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem("moc_lang", lang); }, [lang]);
  useEffect(() => { localStorage.setItem("moc_cart", JSON.stringify(cart)); }, [cart]);

  // translation helper: t("home.heroTitle")
  const t = (path) => {
    const parts = path.split(".");
    let node = translations[lang];
    for (const p of parts) {
      if (node && typeof node === "object" && p in node) node = node[p];
      else return path;
    }
    return node;
  };

  const addToCart = (item) => {
    setCart((prev) => {
      const existing = prev.find((c) => c.id === item.id);
      if (existing) {
        return prev.map((c) => c.id === item.id ? { ...c, qty: c.qty + (item.qty || 1) } : c);
      }
      return [...prev, { ...item, qty: item.qty || 1 }];
    });
  };

  const removeFromCart = (id) => setCart((prev) => prev.filter((c) => c.id !== id));
  const updateQty = (id, qty) => setCart((prev) => prev.map((c) => c.id === id ? { ...c, qty: Math.max(1, qty) } : c));
  const clearCart = () => setCart([]);

  const cartCount = useMemo(() => cart.reduce((s, c) => s + c.qty, 0), [cart]);
  const cartTotal = useMemo(() => cart.reduce((s, c) => s + c.qty * c.price, 0), [cart]);

  const value = { lang, setLang, t, cart, addToCart, removeFromCart, updateQty, clearCart, cartCount, cartTotal };
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useApp = () => {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used within AppProvider");
  return ctx;
};
